import React, { useEffect } from "react";
import styles from "./PropertyProviderPublicPageButton.scss";
import cx from "../utils/cx";
import Button, { IButtonProps } from "./MaterialUi/Button";
import Config from "../utils/Config";
import JsonApiRequest, { IFieldProvider } from "../utils/JsonApiRequest";
import { set } from "lodash";
import RealEstateProvider from "../utils/RealEstateProvider";


const baseUrl = Config.get('baseUrl');

export type IPropertyProviderPublicPageButtonProps = {
    className?: string;
    providerId: IFieldProvider['drupal_internal__id'];
} & Omit<IButtonProps, 'href'>;

const PropertyProviderPublicPageButton: React.FC <IPropertyProviderPublicPageButtonProps> = ({ className = '',providerId, children,  ...rest }) => {

    const [providerUuid, setProviderUuid] = React.useState<IFieldProvider['id'] | undefined>(undefined);


    useEffect(() => {
        // load provider data
        RealEstateProvider.getById(providerId)
            .then((data) => {
                if (data?.has_public_page) {
                    setProviderUuid(data.id);
                } else {
                    setProviderUuid(undefined);
                }
            })
            .catch((e) => {
                console.error(e);
            }).finally(() => {
            // setIsLoading(false);
            })
    }, []);


    const publicPageUrl = providerUuid ? `${baseUrl}anbieter/makler/${providerUuid}` : undefined;


    return publicPageUrl 
        ? <Button  {...rest} href={publicPageUrl} className={cx(styles.propertyProviderPublicPageButton, className)} >{children}</Button>
        : null;
};

export default PropertyProviderPublicPageButton;
